import React from "react";
// import { useNavigate, Link } from "react-router-dom";
import { NavLink, useNavigate } from "react-router-dom";
import "./MainMenu.css";

export default function MainMenu() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch("https://login.abhedasramam.org/myapp/api/logout.php", {
                method: "POST",
            });

            // ❗ Remove authentication
            localStorage.removeItem("auth");

            // 🔴 Trigger logout in all tabs
            localStorage.setItem("logout", Date.now());

            // Redirect to login
            navigate("/");

        } catch (error) {
            console.error("Logout failed:", error);
        }
    };


    return (
        <div>

            <div class="row" style={{ background: 'orange_' }}>
                <div className="container_ containeritems" >
                    <div className="boxes">
                        <NavLink
                            to="../Dashboard"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i className="fa fa-tachometer"></i> &nbsp; &nbsp;
                            <span>Dashboard</span>
                        </NavLink>
                    </div>
                    <div className="boxes">
                        <NavLink
                            to="../HomeUpdates"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i class="fa fa-calendar"></i>&nbsp; &nbsp;
                            <span>Home Events</span>
                        </NavLink>
                    </div>
                    <div className="boxes">
                        <NavLink
                            to="../Updates"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i className="fa fa-cloud"></i>&nbsp; &nbsp;
                            <span>Latest Updates</span>
                        </NavLink>
                    </div>
                    <div className="boxes">
                        <NavLink
                            to="../Emagazine"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i className="fa fa-book"></i>&nbsp; &nbsp;
                            <span>E-Magazine</span>
                        </NavLink>
                    </div>
                    {/* <div className="boxes">
                        <Link to="../Tenders" className="menuitems" ><i class="fa fa-files-o" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <span className="menuitems">Tenders</span></Link>
                    </div> */}

                    <div className="boxes">
                        <NavLink
                            to="../Photo"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i class="fa fa-photo"></i>&nbsp; &nbsp;
                            <span>Gallery</span>
                        </NavLink>
                        {/* <Link to="../Photo" className="menuitems"><i class="fa fa-image" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Gallery</span></Link> */}
                    </div>

                    <div className="boxes">
                        <NavLink
                            to="../DarsanTime"
                            className={({ isActive }) => isActive ? "menuitems active" : "menuitems"}
                        >
                            <i className="fa-regular fa-clock"></i>&nbsp; &nbsp;
                            <span>Temple Timing</span>
                        </NavLink>
                        {/* <Link to="../DarsanTime" className="menuitems" ><i class="fa fa-clock-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Temple Timing</span></Link> */}
                    </div>
                    {/* <div className="boxes">
                        <Link to="../Notices" className="menuitems"><i class="fa fa-cloud" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <span className="menuitems">Updates</span></Link>
                    </div> */}


                    {/* <div className="boxes">
                        <Link to="../Register" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-home" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Register</p></Link>
                    </div> */}
                    <div className="boxes">
                        <span className="menuitems">
                            <i class="fa fa-power-off" aria-hidden="true"></i>
                            <span
                                onClick={handleLogout}
                                className="menuitems">
                                Logout
                            </span>
                        </span>

                    </div>
                </div>
            </div>
        </div>
    );
}
